import { type Types, assignInlineVars, tokens } from '@fiverr-private/theme';
import { generateBorderFocusWithin } from '../../Input/InputGroup/style';
import { TextareaProps } from '../../Textarea/types';
import { formsTokenColors } from '../formsTokenColors';

export const getBorderColor = ({
    disabled,
    isSuccess,
    isError,
}: {
    disabled: TextareaProps['disabled'];
    isSuccess: TextareaProps['isSuccess'];
    isError: TextareaProps['isError'];
}): {
    default: Types.BorderColor;
    hover: Types.BorderColor;
    focus: Types.BorderColor;
} => {
    if (disabled) {
        return {
            default: formsTokenColors.borderColor,
            hover: formsTokenColors.borderColor,
            focus: formsTokenColors.borderColor,
        };
    } else if (isSuccess) {
        return {
            default: 'validationSuccess',
            hover: 'validationSuccess',
            focus: 'validationSuccess',
        };
    } else if (isError) {
        return {
            default: 'validationError',
            hover: 'validationError',
            focus: 'validationError',
        };
    } else {
        return {
            default: formsTokenColors.borderColor,
            hover: formsTokenColors.interactiveColor,
            focus: formsTokenColors.interactiveColor,
        };
    }
};

export const getBorderStyling = ({ disabled, isError, isSuccess, borderFocusWithinVar }) => {
    const borderColor = getBorderColor({ disabled, isSuccess, isError });
    const focusBorderColor = generateBorderFocusWithin({ isError, isSuccess });

    return {
        focusBorderColor,
        borderColor,
        inlineVars: assignInlineVars({ [borderFocusWithinVar]: tokens.colors[focusBorderColor] }),
    };
};
